




































import Vue, { PropType } from 'vue'
import { ValidationProvider } from 'vee-validate'
import type { Element, Validator } from '../UiForm.types'
import UiInput from '../../UiInput'

import UiFormMessage from '../UiFormMessage'

export default Vue.extend({
  name: 'UiFormField',
  components: {
    ValidationProvider,
    UiInput,
    UiFormMessage
  },
  inheritAttrs: false,
  props: {
    field: {
      type: Object as PropType<Element>,
      required: true
    },
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    i18n: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({})
    }
  },
  data () {
    return {
      innerValue: '' as string
    }
  },
  computed: {
    mask (): string|object|boolean {
      return this.field.properties?.mask || false
    },
    placeholder (): string {
      return this.field.properties?.fluidAdditionalAttributes?.placeholder || ''
    },
    required (): boolean {
      return !!Object.keys(this.rules).find(key => key === 'NotEmpty')
    },
    rules (): object {
      const rules = {}
      if (this.field.validators) {
        this.field.validators.forEach((validator: Validator) => {
          if (validator.options) {
            if (validator.identifier === 'RegularExpression') {
              rules[validator.identifier] = validator.options.expression
            } else if (validator.identifier === 'FileSize') {
              rules[validator.identifier] = validator.options.maximum
            } else {
              rules[validator.identifier] = validator.options
            }
          } else {
            rules[validator.identifier] = true
          }
        })
      }

      return rules
    }
  },
  watch: {
    value (newVal): void {
      this.innerValue = newVal
    }
  },
  beforeMount (): void {
    if (this.field.defaultValue && this.field.defaultValue.toString().length > 0) {
      this.innerValue = this.field.defaultValue
    }
  }

})
